import type { JSX, ReactNode } from "react";
export function LeafTag(p: { tone?: "sand" | "cherry" | "apricot" | "sky" | "green" | "ink"; outline?: boolean; children: ReactNode; className?: string }): JSX.Element {
  return <span className={`qy-leaf-tag qy-leaf-tag--${p.tone ?? "green"}${p.outline ? " qy-leaf-tag--outline" : ""} ${p.className ?? ""}`}>{p.children}</span>;
}
